import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class MiddleSection extends Component{
    render(){
        const { themeLayoutId } = this.props;
        return(
            <React.Fragment>
                
                {/* Pet Theme */}

                {themeLayoutId === 'L04' &&
                <section className="p-0 pet-parallax">
                    <div className="full-banner parallax text-center p-center" style={{ backgroundImage: 'url(https://react.pixelstrap.com/multikart/assets/images/parallax/19.jpg)' }}>
                        <div className="container">
                            <div className="row">
                                <div className="col">
                                    <div className="banner-contain">
                                        <h4>choose what you love</h4>
                                        <h3>get upto 70% off</h3>
                                        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
                                        <Link to="/" className="btn btn-solid black-btn" tabIndex="0">shop now</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="pet-decor">
                            <img src="https://react.pixelstrap.com/multikart/assets/images/dog.png" alt="" className="img-fluid blur-up lazyload" />
                        </div>
                    </div>
                </section>
                }

                {/* End Pet Theme */}
            </React.Fragment>
        )
    }
}
export default MiddleSection